/* src/app/umbrella-common/components/review-checklist-documents/review-checklist-document/review-checklist-document.style.scss */
#main-page {
  width: 794px;
  padding: 64px;
  font-family: Arial, sans-serif;
  line-height: 16px;
  font-size: 12px;
  color: #2A2A2A;
}
#main-page .with-space {
  margin-bottom: 15px;
}
#main-page .address-text {
  font-weight: bold;
  color: #007d40;
}
#main-page .declined-header {
  margin-top: 20px;
  font-weight: bold;
  color: #940303;
}
#main-page .comment {
  color: #6A6A6A;
}
#main-page .question-group-title {
  font-weight: bold;
  font-size: 16px;
}
#main-page .question-answers {
  font-weight: bold;
  font-size: 10px;
}
#main-page .client-information {
  font-weight: bold;
}
#main-page .client-information-header {
  margin-top: 15px;
}
#main-page .small-title {
  font-weight: bold;
}
/*# sourceMappingURL=review-checklist-document.style.css.map */
